export default (data) => {
  const decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
  const objDecoded = JSON.parse(decodeURIComponent(escape(decodedString)));
  const { messages } = objDecoded;
  return messages;
};
